import * as React from "react"

import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { MoreVertical } from "lucide-react"
import { cn } from "@/lib/utils"

export interface SurfaceCardMenuItem {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  variant?: 'default' | 'destructive';
}

export interface SurfaceCardProps extends React.ComponentProps<typeof Card> {
  menuItems?: SurfaceCardMenuItem[];
}

export function SurfaceCard({
  className,
  menuItems,
  children,
  ...props
}: SurfaceCardProps) {
  return (
    <Card
      className={cn(
        "bg-gradient-to-br from-[color:var(--agent-surface-from)] to-[color:var(--agent-surface-to)] border-[color:var(--agent-surface-border)] shadow-sm hover:shadow-md transition-shadow relative",
        className
      )}
      {...props}
    >
      {menuItems && menuItems.length > 0 && (
        <div className="absolute top-3 right-3 z-10">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button 
                variant="ghost" 
                size="icon" 
                className="h-8 w-8 rounded-full hover:bg-white/50 text-[color:var(--agent-accent)]"
                onClick={(e) => e.stopPropagation()}
              >
                <MoreVertical className="h-4 w-4" />
                <span className="sr-only">Open menu</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              {menuItems.map((item, index) => (
                <DropdownMenuItem
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    item.onClick();
                  }}
                  className={cn(
                    item.variant === 'destructive' && "text-red-600 focus:text-red-600 focus:bg-red-50"
                  )}
                >
                  {item.icon && <span className="mr-2">{item.icon}</span>}
                  {item.label}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}
      {children}
    </Card>
  )
}
